import axios from 'axios';

const token = document.querySelector('[name=csrf-token]').content;

export default() => {
  return axios.create({
    withCredentials: true,
    baseURL: '/',
    headers: {
      'X-CSRF-Token': token,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}